import {
  Checkbox,
  Icons,
  LinearProgress,
  Switch,
  Tooltip,
} from "@gpstrackit/gtc-react-controls";
import React, { useEffect, useState } from "react";
import { ConcatLabel } from "../../../../../../../components";
import { useIntl } from "react-intl";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateFileLayer } from "../../redux/slice";
import { NotificationManager } from "Components/Notifications";



function updateOriginalName(list, id, name) {
  return list.map(object => {
    if (object?.id === id) {
        return {
            ...object,
            originalName: name
        };
    }
    return object;
  });
}

const ALPHA_NUMERIC_DASH_REGEX = /^[a-zA-Z0-9-]+$/;


export const ItemLayer = ({
  item,
  selectedItem,
  selectedItems,
  searchItemInPreferences,
  searchLayerOnTheMap,
  mapRef,
  disabledSwitch,
  showItem,
  showItems,
  data,
  setData
}) => {
  const { messages } = useIntl();
  const dispatch = useDispatch();

  const { updateFile, loadingUpdateFile, resUpdateFile } = useSelector(
    (state) => state.filesRedux
  );
  const presignedUrlsResponse = useSelector(state => state.filesRedux.presignedUrlsResponse);
  

  const [updateItems, setUpdateItems] = useState([]);
  const [updateNameFile, setUpdateNameFile] = useState([]);
  const [loadingFile, setLoadingFile] = useState({});
  const [newName, setNewName] = useState({})
  const [showUpdateIcon, setShowUpdateIcon] = useState(false)

  useEffect(() => {
    if (updateFile[item?.id]) {
        const copyItems = { ...loadingFile };
        delete copyItems[item?.id];
        setLoadingFile({ ...copyItems })
    }
  }, [updateFile]);

  const isUpdateItem = (_item) => {
    let flag = false;
    const searchItem = updateItems?.find(
      (updateItem) => updateItem?.id === _item?.id
    );
    if (searchItem) flag = true;
    return flag;
  };

  const validateName = (item, newName, list) => {

    let flag = true
    let messageError = ''

    const name = item?.originalName?.split(".")[0];
    if(newName[item?.id]?.newName?.length === 0){
      messageError = 'realtimemaps_layer_map_layer_empty_name_warning'
      flag = false
    }

    if(newName[item?.id]?.newName?.length > 50){
      messageError = 'realtimemaps_layer_map_layer_max_name_warning'
      flag = false
    }

    if (newName[item?.id]?.newName === name){
      messageError = 'realtimemaps_layer_map_layer_used_name_warning'
      flag = false
    }


    const findName = list?.find(itemList => itemList?.originalName?.split(".")[0]?.toLowerCase() === newName[item?.id]?.newName?.toLowerCase())
    if(findName) {
      messageError = 'realtimemaps_layer_map_layer_used_name_warning'
      flag = false
    }

    if(messageError && !flag){
      NotificationManager.warning(
        messages[messageError],
        messages['realtimemaps_layer_map_layer_warning'],
        3000,
        null,
        null,
        'warning',
        null
      );
    }


    return flag
  }

  const augmentedSearchLayerOnTheMap = async (item, mapRef) => {
    try {
        const getItemFromPresigned = presignedUrlsResponse.find(i => i.id === item.id)
        if(getItemFromPresigned){
          searchLayerOnTheMap(
            getItemFromPresigned,
            mapRef
          )
        }
    } catch (error) {
      NotificationManager.warning(messages["realtimemaps_layer_map_layer_files_uploaded_no_files"], messages["warning"], 3000);
    }
  };

  const clearUpdateItem = (updateItem) => {
    const copyItems = { ...updateNameFile };
    delete copyItems[updateItem?.id];
    setUpdateNameFile({ ...copyItems });
    const update = updateItems.filter((data) => data?.id !== updateItem?.id);
    setUpdateItems(update);   
  };

  const updateItem = (updateItem) => {
    const extension = item?.originalName?.split(".")[1];
    if(!validateName(item, newName, data)) return
    setLoadingFile({ ...loadingFile, [item?.id]: true });
    dispatch(updateFileLayer({
        id: updateItem?.id,
        originalName: `${newName[item?.id]?.newName}.${extension}`
    }))
    const updateList = updateOriginalName(data, item?.id, newName[item?.id]?.newName)
    setData(updateList)
    clearUpdateItem(item)
  };

  return (
    <div>
      <div className="container_items_layerKmz">
        <div
            onMouseEnter={() => setShowUpdateIcon(true)}
            onMouseLeave={() => setShowUpdateIcon(false)}
            key={item?.id} className="container_item_layerKmz"
          >
          <div
            style={{
              marginLeft: "10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Checkbox
              onChange={(e) => selectedItem(item, e)}
              checked={selectedItems?.find(
                (selected) => selected?.id === item?.id
              )}
            />
            {!isUpdateItem(item) ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ConcatLabel
                  username={item?.originalName?.split(".")[0]}
                  concatLimit={10}
                />
                {
                  showUpdateIcon && 
                  <Icons
                    size="small"
                    style={{ marginLeft: "10px", cursor: "pointer" }}
                    name="edit"
                    onClick={() => {
                      const index = item?.id;
                      setUpdateItems([...updateItems, item]);
                      setNewName({
                        ...updateNameFile,
                        [index]: { ...item, newName: item?.originalName?.split(".")[0] },
                      })
                      setUpdateNameFile({
                        ...updateNameFile,
                        [index]: {
                          ...item,
                          ...newName[item?.id]?.newName
                        },
                      });
                    }}
                  />
                }
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "10px",
                }}
              >
                <TextField
                  defaultValue={item?.originalName?.split(".")[0]}
                  variant="standard"
                  onKeyDown={(event) => {
                    if (!ALPHA_NUMERIC_DASH_REGEX.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    const text = e.target.value;
                    const index = item?.id;
                    setNewName({
                      ...updateNameFile,
                      [index]: { ...item, newName: text },
                    })
                    setUpdateNameFile({
                      ...updateNameFile,
                      [index]: { ...item, newName: text },
                    });
                  }}
                  inputProps={{ maxLength: 50 }}
                  size="small"
                />
                <Tooltip title={messages["cancel"]}>
                  <Icons
                    size="small"
                    style={{ marginLeft: "10px", cursor: "pointer" }}
                    name="cancel"
                    color="red"
                    onClick={() => {
                      const copyItemsNewName = { ...newName };
                      delete copyItemsNewName[item?.id];
                      setNewName(copyItemsNewName); 
                      clearUpdateItem(item)
                    }}
                  />
                </Tooltip>
                <Tooltip title={messages["update"]}>
                  <Icons
                    size="small"
                    style={{ marginLeft: "10px", cursor: "pointer" }}
                    name="check"
                    color="green"
                    onClick={() => updateItem(item)}
                  />
                </Tooltip>
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {searchItemInPreferences(item) && (
              <div style={{ marginTop: "4px" }}>
                <Tooltip
                  title={messages["realtimemaps_layer_map_layer_follow"]}
                >
                  <Icons
                    size="medium"
                    style={{ marginRight: "10px", cursor: "pointer" }}
                    name="visibility"
                    onClick={() =>
                      augmentedSearchLayerOnTheMap(
                        item,
                        mapRef
                      )
                    }
                  />
                </Tooltip>
              </div>
            )}
            <div style={{ width: "100px" }}>
              <Switch
                isDisabled={disabledSwitch(item)}
                optionLabels={[messages["show"], messages["hide"]]}
                onChange={(e) => {
                  showItem(e, item);
                }}
                checked={showItems?.find(
                  (selected) => selected?.id === item?.id
                )}
              />
            </div>
          </div>
        </div>
        {loadingFile[item?.id] && loadingUpdateFile && (
          <div>
            <LinearProgress key={item?.id} />
          </div>
        )}
      </div>
    </div>
  );
};
